/*
 * Actions file for Main State.
 *
 * TO LAUCH COMMIT OVER THE MUTATIONS FUNCTIONS
 * - RULES:
 *   - NOT DIRECT STATE MODIFICATIONS
 *   - ALL BUSINESS LOGIC NEEDED BASED ON THE STATE AND NEW/MOD INFO
 *   - CAN CONTAIN ASYNC API CALLS
 *
 */

/*
 * TO CALL THIS ACTION FROM COMPONENT .VUE:
 *  - within the methods section in a method
 *  - call: this.$store.dispatch('addProductToCart', this.product);
 * */

import axios from "axios";
import LazLocalStorage from "@/shared/utils/LazLocalStorage.js";
import NProgress from "nprogress";
import authOkta from '@/shared/services/auth/authOkta';
//import { msalLogin, msalLogout } from "@/shared/services/auth/MSALServiceV1";

/*
 *  Hace el Login para cazar dos cosas, el token de JWT y los roles de usuario.
 * @param { any } param0
    * @param { string } body*/

export const Login = async function ({ state, commit }) {

    /* Petición del token de autorización */
    console.log("[Store Action] - Login init");
    try {
        let authToken = JSON.parse(localStorage.getItem('iris.auth.token.v2-0-0'));

        //Si tengo un token guardado en el localstorage no necesito lanza login alguno
        if (!authToken) {
            let tokenAuth = null
            await authOkta.login();
            tokenAuth = await authOkta.getToken();
            if (tokenAuth !== null) {
                const { data: authJWT } = await axios.post('/api/Login', tokenAuth);

                authToken = authJWT.token;
            }
        }
        if (authToken !== null) {
            let idToken = JSON.parse(authToken.access_token).idToken;

            /* Se fija en el header de autorización para todas las llamadas de aquí en adelante */
            axios.defaults.headers.common["Authorization"] = `Bearer ${idToken}`;

            /* Se guarda en el local storage para intersesiones */
            localStorage.setItem('iris.auth.token.v2-0-0', JSON.stringify(authToken));


            /* Se lanza para la gestión en el vuex */
            commit('LoginSuccess', authToken);

            commit('AuthReady', true);
            console.log("[Store Action] - Login end");

        }

    } catch (error) {
        console.log('auth error', error);
    }
};

/**
 * Acción para hacer el logout.
 * @param {any} param0
 */
export const Logout = function ({ commit }) {
    commit("Logout");

    authOkta.logout();
    /* Se elimina de toda cabecera de autorización el bearer */
    delete axios.defaults.headers.common["Authorization"];

    localStorage.removeItem("iris.auth.token.v2-0-0");
};

/**
 * Acción para modificar el LangCode
 * @param {any} param0
 * @param {any} body
 */
export const SetLangCode = function ({ commit }, langCode) {
    LazLocalStorage.setWithExpiry(
        "LazLangCode",
        langCode,
        1000 * 3600 * 24 * 365
    );
    commit("LangCode", langCode);
};

/**
 * Acción para almacenar la instancia en el local storage
 * @param {any} param0
 * @param {any} instance instancia
 */
export const SetInstance = function ({ commit }, instance) {
    LazLocalStorage.setWithExpiry(
        "LazInstance",
        instance,
        1000 * 3600 * 24 * 365
    );
    commit("Instance", instance);
};

/**
 * Acción para cambiar la instancia
 * @param {any} user Mail de usuario
 * @param {any} instance Nueva instancia a la que se quiere cambiar
 *
 */
export const ChangeInstance = function ({ dispatch }, { user, instance }) {
    /* Generar modelo para petición */
    let instanceModel = {
        UserMail: user,
        NewInstance: instance,
    };
    /* Llamada para realizar cambio de instancia */
    axios
        .post("api/Login/ChangeUserInstance", instanceModel)
        .then((response) => {
            if (response.data === true) {
                // Set new isntance
                dispatch("SetInstance", instance);

                // Borrar roles caché y refrescar
            }
        })
        .catch((error) => {
            console.log(error);
        })
        .finally(() => { });
};

/**
 * Acción para obtener la instancia de un usuario del servidor
 * @param {any} user Mail del usuario
 */
export const GetInstanceFromServer = function ({ dispatch }, user) {
    /* Llamada para obtener la instancia */
    axios
        .get("api/Login/GetUserInstance?user=" + user)
        .then((response) => {
            if (response.data !== null) {
                // Set instance
                dispatch("SetInstance", response.data);
            } else {
                // set default 'es' instance
                dispatch("SetInstance", null);
            }
        })
        .catch((error) => {
            console.log(error);
        })
        .finally(() => { });
};

/**
 * Acción para obtener un CodParam desde el servidor y llevarlo al estado.
 * @param {any} param0
 * @param {any} codParam
 */
export const GetCodParamFromServer = function ({ state, commit }, codParam) {
    /* Se itera por los paramListItem para ver si está en el el estado */
    for (var lCnt = 0; lCnt < state.paramListItems.length; lCnt++) {
        /* Si el lenguaje y el codparam están */
        if (
            state.paramListItems[lCnt].codParam == codParam &&
            state.paramListItems[lCnt].langCode == state.langCode
        ) {
            /* Elemento encontrado en el estate ya descargado del servidor */
            return;
        }
    }
    /* Se busca dentro de los paramList guardados en el localstorage */
    var storedParamList = LazLocalStorage.getWithExpiry(
        "LazCodParam-" + codParam + "-" + state.langCode
    );
    if (storedParamList != null) {
        /* Se lanza el cambio en el estado por mutación */
        commit("SetParamListItem", storedParamList);
    } else {
        /* No se ha encontrado el paramList no se ha descargado y se procede a descargar */
        axios
            .get(
                `api/Common/GetComboItems?codParam=${codParam}&lang=${state.langCode}`
            )
            .then((response) => {
                if (response.data.hasOwnProperty("result")) {
                    if (response.data.result === true) {
                        var disctServerPairs = response.data.data;

                        /* Se crea el objeto a meter en el estado */
                        let nItem = {
                            codParam: codParam,
                            langCode: state.langCode,
                            dictPairs: disctServerPairs,
                        };
                        /* Se lanza el cambio en el estado por mutación y se guarda en el localstorage */
                        LazLocalStorage.setWithExpiry(
                            "LazCodParam-" + nItem.codParam + "-" + nItem.langCode,
                            nItem,
                            1000 * 3600 * 24
                        );
                        commit("SetParamListItem", nItem);
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => { });
    }
};

/**
 * Acción para obtener un paramId desde el servidor y llevarlo al estado.
 * @param {any} param0
 * @param {any} paramId
 */
export const GetParamIdFromServer = async function ({ state, commit, dispatch }, paramId) {
    if (state.langCode == null) {
        dispatch("SetLangCode", "en");
    }
    if (state.langCode != null) {
        /* Se itera por los paramListItem para ver si está en el el estado */
        for (var lCnt = 0; lCnt < state.paramListItems.length; lCnt++) {
            /* Si el lenguaje y el codparam están */
            if (
                state.paramListItems[lCnt].paramId == paramId &&
                state.paramListItems[lCnt].langCode == state.langCode
            ) {
                /* Elemento encontrado en el estate ya descargado del servidor */
                return;
            }
        }
        /* Se busca dentro de los paramList guardados en el localstorage */
        var storedParamList = LazLocalStorage.getWithExpiry(
            "LazParamId-" + paramId.toString() + "-" + state.langCode
        );
        if (storedParamList != null) {
            /* Se lanza el cambio en el estado por mutación */
            commit("SetParamListComboItem", storedParamList);
        } else {
            /* No se ha encontrado el paramList no se ha descargado y se procede a descargar */
            await axios
                .get(`api/Common/GetParamListById?id=${paramId}&lang=${state.langCode}`)
                .then((response) => {
                    var list = response.data;

                    /* Se crea el objeto a meter en el estado */
                    let nItem = {
                        paramId: paramId,
                        langCode: state.langCode,
                        values: list,
                    };
                    /* Se lanza el cambio en el estado por mutación y se guarda en el localstorage */
                    LazLocalStorage.setWithExpiry(
                        "LazParamId-" + paramId.toString() + "-" + state.langCode,
                        nItem,
                        1000 * 3600 * 24
                    );
                    commit("SetParamListComboItem", nItem);
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => { });
        }
    }
};


export const OnUsersCacheRefresh = function ({ dispatch }, refreshKey) {
    dispatch('RolesModule/REFRESH', refreshKey);
    dispatch('UsersModule/REFRESH', refreshKey);
    dispatch('UsersModule/REFRESHASSOCIATED', refreshKey);
    dispatch('ProfilesModule/REFRESH', refreshKey);
    dispatch('ProfilesModule/REFRESHASSOCIATED', refreshKey);

}

/**
 * cierra el widget card buffer
 * @param {any} commit
 */
export const openWidgetCardsBuffer = function ({ commit }) {
    commit("setWidgetCardsBufferCollapsed", false);
};

/**
 * abre el widget card buffer
 * @param {any} commit
 */
export const collapseWidgetCardsBuffer = function ({ commit }) {
    commit("setWidgetCardsBufferCollapsed", true);
};

/**
 * agrega un item al widget card buffer
 * @param {any} commit
 * @param {any} item
 */
export const insertWidgetCard = function ({ commit }, item) {
    console.log(item)
    commit("pushWidgetCard", item);
    commit("setWidgetCardsBufferCollapsed", false);
};

/**
 * retira un item por keyid del widget card buffer
 * @param {any} commit
 * @param {any} item
 */
export const removeWidgetCard = function ({ commit }, keyId) {
    console.log(keyId)
    commit("removeWidgetCard", keyId);

};


export const componentsActivation = function (
    { state, commit },
    updateComponent
) {
    if (updateComponent) {
        // Update activation of a component in state object
        let oldState = state.componentsActivation.find(
            (f) => f.component === updateComponent.component
        );
        if (oldState) {
            // Update
            oldState.isActive = updateComponent.isActive;
        } else {
            // Add
            state.componentsActivation.push(updateComponent);
        }
        LazLocalStorage.setWithExpiry(
            "ComponentsActivation",
            state.componentsActivation,
            1000 * 3600 * 24 * 365
        );
        commit("ComponentsActivation", state.componentsActivation);
    } else {
        // Look into local storage
        var storedComponentsActivation = LazLocalStorage.getWithExpiry(
            "ComponentsActivation"
        );
        // Set default values
        if (!storedComponentsActivation || storedComponentsActivation.length == 0) {
            let defaultComponentsActivation = [
                {
                    component: "Comparables",
                    isActive: true,
                },
                {
                    component: "PortfolioComparables",
                    isActive: false,
                },
                {
                    component: "ComparablesBasket",
                    isActive: true,
                },
                {
                    component: "AreaOfInterest",
                    isActive: true,
                },
                {
                    component: "Indicators",
                    isActive: false,
                },
            ];
            // Save into local storage
            LazLocalStorage.setWithExpiry(
                "ComponentsActivation",
                defaultComponentsActivation,
                1000 * 3600 * 24 * 365
            );
            // Commit
            commit("ComponentsActivation", defaultComponentsActivation);
        } else {
            // Commit
            commit("ComponentsActivation", storedComponentsActivation);
        }
    }
};

/**
 * Acción para obtener una lista de paramlist desde el estado/localStorage/servidor y llevarlo al estado.
 * @param {any} param0
 * @param {any} codes
 */
export const FetchParamListsByCode = function ({ dispatch }, codes) {
    if (!Array.isArray(codes))
        throw new Error(
            `Action GetParamListsByCode got ${codes} instead of an array`
        );
    codes.forEach((code) => dispatch("GetCodParamFromServer", code));
};


